import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import React from 'react';
import moment from 'moment';

export const cellAnswerTypes = [
  'boolean',
  'select',
  'text',
  'number',
  'date',
  'dateRange',
  'email',
  'range',
  'consent',
  'bmi',
];
export const rowAnswerTypes = ['tableField', 'richtext', 'textarea'];
export const formElementTypes = [
  'pageTitle',
  'body',
  'title',
  'subtitle',
  'image',
  'summary',
];
export const noVisibleTypes = ['file', 'button'];

export const generateTable = (columns, formData) => {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {columns.map((col) => (
            <TableCell>
              <b>{col}</b>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {formData?.map((row) => (
          <TableRow>
            {row.map((cell) => (
              <TableCell>{cell}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export const isNotAnswered = (formDefinition, formData) => {
  if (formData === undefined) {
    return true;
  }

  if (formDefinition.multiValued) {
    return (
      formData.length === 0 ||
      (formData.length > 0 &&
        formData.every((data) =>
          isNotAnswered({ ...formDefinition, multiValued: false }, data)
        ))
    );
  }

  switch (formDefinition.type) {
    case 'select':
    case 'text':
    case 'email':
    case 'textarea':
    case 'richtext':
      return formData === '';
    case 'consent':
      return formData === false;
    case 'boolean':
      return formDefinition.handleFalseAsUndefined && formData === false;
    case 'multiselect':
      return formData.length === 0;
    case 'tableField':
      try {
        const tableData = JSON.parse(formData);
        return tableData.table === undefined || tableData.table.length === 0;
      } catch (e) {
        return true;
      }
    case 'dateRange':
      return Object.keys(JSON.parse(formData)).length === 0;
  }

  return false;
};

export const dataValueFlat = (element, formData) => {
  if (formData === undefined) {
    return null;
  }
  switch (element.type) {
    case 'text':
    case 'number':
    case 'range':
    case 'textarea':
    case 'richtext':
      return formData;
    case 'bmi':
      return `${formData} kg/m²`;
    case 'select':
      return element.messages?.fi?.[`value.${formData}`] ?? formData.toString();
    case 'multiselect':
      return formData
        .map((data) => dataValueFlat({ ...element, type: 'select' }, data))
        .join(', ');
    case 'boolean':
      return (
        element.messages.fi[`value.${formData}`] ??
        (formData === true ? 'Kyllä' : formData === false ? 'Ei' : null)
      );
    case 'date':
      return moment(formData, 'YYYY-MM-DD').format('DD.MM.yyyy');
    case 'dateRange':
      let data = JSON.parse(formData);
      return `${
        data.start ? moment(data.start, 'YYYY-MM-DD').format('DD.MM.yyyy') : ''
      } - ${
        data.end ? moment(data.end, 'YYYY-MM-DD').format('DD.MM.yyyy') : ''
      }`;
    default:
      return formData.toString();
  }
};
